import React from "react";
import "./portfolio.css";
import IMG1 from '../../assets/pf.png';
import IMG2 from '../../assets/OOP.png';
import IMG3 from '../../assets/dsa.png';
import IMG4 from '../../assets/coal.png';
import VID from '../../assets/BB.png';

const Portfolio = () => {

  // Function to handle private link clicks
  const handlePrivateClick = (projectName) => {
    alert(`The link for ${projectName} is Private. Please provide the Correct Email Address to FORM below to have the Excess`);
  };

  // Function to handle href link clicks and track event in GA4
  const handleLinkClick = (projectName, linkUrl) => {
    window.gtag('event', 'link_click', {
      event_category: 'portfolio',
      event_label: projectName,
      value: linkUrl,
    });
  };

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG1} alt="Programming Fundamental" />
          </div>
          <h3>Programming Fundamental (PF)</h3>
          <div className="portfolio__item-cta">
            <a 
              href="https://github.com/ParthamKumar/Programming-Fundamental" 
              className="btn" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleLinkClick('Programming Fundamental', 'https://github.com/ParthamKumar/Programming-Fundamental')}
            >
              Github
            </a>
            <a
              href="https://github.com/ParthamKumar/Programming-Fundamental"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
              onClick={() => handleLinkClick('Programming Fundamental', 'https://github.com/ParthamKumar/Programming-Fundamental')}
            >
              Public
            </a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG2} alt="Object Oriented Programming" />
          </div>
          <h3>Object Oriented Programming (OOP)</h3>
          <div className="portfolio__item-cta">
            <a 
              href="https://github.com/ParthamKumar/Object-Oriented-Programming" 
              className="btn" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleLinkClick('Object Oriented Programming', 'https://github.com/ParthamKumar/Object-Oriented-Programming')}
            >
              Github
            </a>
            <a
              href="https://github.com/ParthamKumar/Object-Oriented-Programming"
              className="btn btn-primary"
              target="_blank"
              rel="noreferrer"
              onClick={() => handleLinkClick('Object Oriented Programming', 'https://github.com/ParthamKumar/Object-Oriented-Programming')}
            >
              Public
            </a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG3} alt="Data Structures And Algorithms" />
          </div>
          <h3>Data Structures And Algorithm (DSA)</h3>
          <div className="portfolio__item-cta">
            <a 
              href="https://github.com/ParthamKumar/Data-Structures-And-Algorithms-DSA-in-C-" 
              className="btn" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleLinkClick('Data Structures And Algorithms (DSA)', 'https://github.com/ParthamKumar/Data-Structures-And-Algorithms-DSA-in-C-')}
            >
              Github
            </a>
            <a
              className="btn btn-primary"
              onClick={() => handlePrivateClick('Data Structures And Algorithms (DSA)')}
              target="_blank"
              rel="noreferrer"
            >
              Private
            </a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG4} alt="Computer Organization and Assembly Language (COAL) 8086" />
          </div>
          <h3>Computer Organization and Assembly Language (COAL) 8086</h3>
          <div className="portfolio__item-cta">
            <a 
              href="https://github.com/ParthamKumar/Computer-Organization-Assembly-Language-COAL-" 
              className="btn" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleLinkClick('Computer Organization and Assembly Language (COAL) 8086', 'https://github.com/ParthamKumar/Computer-Organization-Assembly-Language-COAL-')}
            >
              Github
            </a>
            <a
              className="btn btn-primary"
              onClick={() => handlePrivateClick('Computer Organization and Assembly Language (COAL) 8086')}
              target="_blank"
              rel="noreferrer"
            >
              Private
            </a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={VID} alt="BudgetBee A Java Project (Android)" />
          </div>
          <h3>BudgetBee A Java Project (Android)</h3>
          <div className="portfolio__item-cta">
            <a 
              href="https://github.com/ParthamKumar/BudgetBee" 
              className="btn" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleLinkClick('BudgetBee A Java Project (Android)', 'https://github.com/ParthamKumar/BudgetBee')}
            >
              Github
            </a>
            <a
              className="btn btn-primary"
              onClick={() => handlePrivateClick('BudgetBee A Java Android Application Project')}
              target="_blank"
              rel="noreferrer"
            >
              Private
            </a>
            <a
              href="https://www.linkedin.com/feed/update/urn:li:activity:7217181836064546818/"
              className="btn btn-primary" 
              target="_blank" 
              rel="noreferrer"
              onClick={() => handleLinkClick('BudgetBee A Java Project (Android) - Demo', 'https://www.linkedin.com/feed/update/urn:li:activity:7217181836064546818/')}
            >
              Demo
            </a>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Portfolio;
